import Typography from "@mui/material/Typography";
import {Grid} from "@mui/material";
import {useTranslation} from "react-i18next";
import {FC} from "react";
import ButtonWithProgress from "../button-with-progress/ButtonWithProgress";

interface IProps {
    counter: number
    handleOnSubmitClick: () => void
    color: 'primary' | 'secondary'
}

const ResendEmail: FC<IProps> = (props) => {
    const {t} = useTranslation()

    return (
        <Grid container alignItems='center' sx={{mt: 2}}>
            <Typography variant='body2' mr={2} color={props.color}>{t('didnt_get_email')}</Typography>
            <ButtonWithProgress color={props.color}
                                buttonLabel={t('resend')}
                                seconds={30}
                                counter={props.counter}
                                handleOnSubmitClick={props.handleOnSubmitClick}/>
        </Grid>
    )
}

export default ResendEmail
